<template>
  <div style="padding: 15px" class="bg-white" v-loading="isLoading">
    <el-row v-if="!is_disabled" :gutter="15">
      <el-col :sm="12">
        <label>Customer</label>
        <el-select :disabled="is_disabled" v-model="customer" filterable @change="getTableData">
          <el-option
            v-for="(c, index) in customers"
            :key="index"
            :value="c.id"
            :label="c.name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :sm="12">
        <label>Status</label>
        <el-select v-model="status" placeholder="ALL" clearable multiple>
          <el-option
            v-for="(s, index) in statusList"
            :key="index"
            :value="s.code"
            :label="s.name"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row  v-if="!is_disabled" class="mt-1">
      <el-col>
        <el-button type="primary" @click="getTableData"
          >Get Pending Job Orders</el-button
        >
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-table row-key="temp" border :data="tableData" default-expand-all>
        <el-table-column min-width="130" label="" prop="label">
        </el-table-column>
        <el-table-column label="ID Code" prop="uld_id_code"></el-table-column>
        <el-table-column
          label="Manufacturer"
          prop="manufacturer_name"
        ></el-table-column>
        <el-table-column v-if="!is_disabled" label="JO Number">
          <template slot-scope="scope">
            <a
              :href="`/repair/repair-uld/info/${scope.row.id}`"
              target="_blank"
              >{{ scope.row.job_order_number }}</a
            >
          </template>
        </el-table-column>
        <el-table-column label="Date Received">
          <template slot-scope="scope">
            <span v-if="scope.row.date_received">{{
              scope.row.date_received | dateFormat("LL")
            }}</span></template
          >
        </el-table-column>
        <el-table-column label="Remarks" prop="remarks"></el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "DashboardPending",
  data: () => ({
    isLoading: false,
    customer: "",
    status: [],
    tableData: [],
    is_disabled: false,
    tempGrandTotal: 0,
    GrandTotal: 0
  }),
  computed: {
    customers() {
      if(this.$store.getters["dashboard/customers"].length == 1) {
        this.customer = this.$store.getters["dashboard/customers"][0]['id'];
        this.getTableData();
        this.is_disabled = true;
      }
      return this.$store.getters["dashboard/customers"];
    },
    statusList() {
      return this.$store.getters["dashboard/statusList"];
    },
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  methods: {
    getTableData() {
      if (this.customer) {
        let customer = this.customer;
        let status = this.status.length ? this.status.toString() : "all";

        this.isLoading = true;
        api
          .get(`/api/v1/dashboard/view_pending_status/`, {
            customer_id: customer,
            status_code: status
          })
          .then(resp => {
            this.isLoading = false;

            this.tableData = [];
            if (resp && resp.data) {
              let info = resp.data.data.msg;
              let root = {
                label: info.customer,
                children: [],
                temp: Math.random()
              };
              for (let result of info.result) {
                var grandTotal = 0;
                for(var i = 0; i< result.uld.length; i++ ) {
                 grandTotal += result.uld[i].count;
                }
                let stat = {
                  label: `${result.status} Total`,
                  temp: Math.random(),
                  uld_id_code: grandTotal,
                  children: []
                };
                let statusChildCtr = 0;
                root.children.push(stat);
                for (let uld of result.uld) {
                  let stat_uld = {
                    label: `${uld.description} Total`,
                    uld_id_code: uld.count,
                    temp: Math.random(),
                    children: []
                  };
                  stat.children.push(stat_uld);
                  for (let item of uld.data) {
                    stat_uld.children.push({ ...item, temp: Math.random() });
                    statusChildCtr++;
                  }
                  // stat_uld.children.push({
                  //   label: `${uld.description} Total`,
                  //   uld_id_code: uld.count,
                  //   temp: Math.random()
                  // });
                }
                // stat.children.push({
                //   label: `${result.status} Total`,
                //   uld_id_code: statusChildCtr,
                //   temp: Math.random()
                // });
              }

              root.children.push({
                label: `${info.customer} Total`,
                uld_id_code: info.total,
                temp: Math.random()
              });

              this.tableData.push(root);
            }
          });
      }
    },
  },
  mounted() {
    this.$store.dispatch("dashboard/getCustomers");
  }
};
</script>

<style lang="scss" scoped></style>
